import { type FormAnchorNavSection } from '@/components/form/form-anchor-nav.tsx'

export const RENTAL_FORM_SECTIONS: FormAnchorNavSection[] = [
  { id: 'order-info', title: '订单归属' },
  { id: 'rental-resource', title: '租赁业务与地址' },
  { id: 'service-enterprise', title: '服务对象及资料' },
  { id: 'rental-contract', title: '合同设置' },
  { id: 'rental-price', title: '协议价格' },
  { id: 'rental-attachments', title: '附件与备注' },
  { id: 'service-items', title: '附加服务' }
]

export const RENTAL_BATCH_FORM_SECTIONS: FormAnchorNavSection[] = [
  { id: 'rental-quantity', title: '生成订单数量' },
  { id: 'order-info', title: '订单归属' },
  { id: 'rental-resource', title: '租赁业务与地址' },
  { id: 'rental-price', title: '协议价格' },
  { id: 'rental-contract', title: '合同设置' },
  { id: 'rental-notes', title: '备注' }
]
